import { dataLayerPush } from '@r1-frontend/analytics/dataLayerPush';

import { CATEGORIES, EVENTS } from '@r1-frontend/shared/constants/analytics';
import { pluralize } from '@r1-frontend/shared/helpers/pluralize';
import { monthPluralize } from '@r1-frontend/shared/helpers/pluralize/predifined';

interface ILabelProps {
    countMonth: number,
    sumPrice: number,
    deltaPeriod: number,
}

export const getTicketDataLayerLabel = ({ countMonth, sumPrice, deltaPeriod }: ILabelProps) => {
    return `duration:${countMonth}_${pluralize(countMonth, monthPluralize)}|cost:${sumPrice}|savings:${deltaPeriod}|`;
};

export const pushDataLayer = (action: string, label?: string) => {
    dataLayerPush({
        event: EVENTS.UAevent,
        category: CATEGORIES.seasonTickets,
        action,
        label,
    });
};
